import { PermissionAction } from "./actions";
import { OrganizationRole } from "./roles";
import { PermissionSubject } from "./subjects";

export type PermissionString = `${PermissionAction}:${PermissionSubject}`;

export function formatPermission(action: PermissionAction, subject: PermissionSubject): PermissionString {
  return `${action}:${subject}`;
}

export function parsePermission(permission: string): { action: string; subject: string } {
  const separatorIndex = permission.indexOf(":");
  if (separatorIndex === -1) {
    return { action: permission, subject: "all" };
  }
  return {
    action: permission.slice(0, separatorIndex),
    subject: permission.slice(separatorIndex + 1),
  };
}

const p = formatPermission;

export const ROLE_PERMISSION_PRESETS: Record<string, PermissionString[]> = {
  [OrganizationRole.ADMIN]: [
    p(PermissionAction.MANAGE, PermissionSubject.ALL),
    p(PermissionAction.MANAGE, PermissionSubject.BILLING),
  ],
  // A trainer who is not the owner runs the whole coaching side - the schedule, their clients'
  // plans, progress and packs - but cannot change the business itself, its billing or see its
  // money. They can read the offers so they can tell a client what is on sale.
  [OrganizationRole.MEMBER]: [
    p(PermissionAction.READ, PermissionSubject.ORGANIZATION),
    p(PermissionAction.READ, PermissionSubject.USER),
    p(PermissionAction.MANAGE, PermissionSubject.BOOKING),
    p(PermissionAction.MANAGE, PermissionSubject.ENTRY_PACK),
    p(PermissionAction.MANAGE, PermissionSubject.TRAINING_PLAN),
    p(PermissionAction.MANAGE, PermissionSubject.DIET_PLAN),
    p(PermissionAction.MANAGE, PermissionSubject.PROGRESS),
    p(PermissionAction.MANAGE, PermissionSubject.EXERCISE),
    p(PermissionAction.READ, PermissionSubject.OFFER),
  ],
};
